// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"396662a3","787":"5d0ce261"}[chunkId] + ".chunk.js";
};